"use client"

import { createContext, useState, ReactNode } from "react";

export interface CountdownContextValue {
  hasFinished: boolean;
  setHasFinished: (finished: boolean) => void;
}

export const CountdownContext = createContext<CountdownContextValue>({
  hasFinished: false,
  setHasFinished: () => { },
});

interface CountdownProviderProps {
  children: ReactNode;
}

export const CountdownProvider = ({ children }: CountdownProviderProps) => {
  const [hasFinished, setHasFinished] = useState(false);

  return (
    <CountdownContext.Provider value={{ hasFinished, setHasFinished }}>
      {children}
    </CountdownContext.Provider>
  );
};
